import { z } from 'zod';

export const baseResponseSchema = z.object({
  message: z.string().optional(),
  timestamp: z.string().optional(),
});

export const paginationSchema = z.object({
  page: z.number(),
  perPage: z.number(),
  total: z.number(),
});

export const createPaginatedApiResponse = <T extends z.ZodTypeAny>(schema: T) =>
  z.object({
    message: z.string().nullable().optional(),
    data: z.array(schema),
    meta: paginationSchema,
    timestamp: z.string().nullish(),
  });

export const createApiResponse = <T extends z.ZodTypeAny>(schema: T) =>
  z.object({
    message: z.string().nullable().optional(),
    data: schema,
    timestamp: z.string().nullish(),
  });
